module.exports = "https://static.wmbcdn.com/uniweb/images/73677773c13bd03e49e1a9d9d204b8d3.svg";